import MathRenderer from "./math_renderer"

export default class Sliders {
    constructor() {
        this.sliders = document.querySelectorAll(".swiper")
        this.sliders.forEach( el => this.setup(el))
    }

    setup(_container) {
        let swiper = new Swiper(_container, {
            keyboard: {
                enabled: true,
            },
            pagination: {
                clickable: true,
                el: _container.querySelector('.pagination'),
                renderBullet: (index, className) => {
                    return '<span class="' + className + ' index-item">' + (index + 1) + "</span>"
                }
            },
            autoHeight: true,
            navigation: {
                nextEl: _container.querySelector('.button-next'),
                prevEl: _container.querySelector('.button-prev'),
            }
        }).on("slideChange", (swiper) => {
            // Renderizar fórmulas matemáticas en el slide activo
            const activeSlide = swiper.slides[swiper.activeIndex]
            if (activeSlide) {
                setTimeout(() => {
                    new MathRenderer(activeSlide)
                }, 50)
            }
        }).on("init", (swiper) => {
            // Renderizar fórmulas en el slide inicial
            const activeSlide = swiper.slides[swiper.activeIndex]
            if (activeSlide) {
                setTimeout(() => {
                    new MathRenderer(activeSlide)
                }, 100)
            }
        })
    }
}